export default __webpack_public_path__ + "static/media/Gemeine-Ziege.1cbe5d6a.webp";